<template>
  <header class="ods-header">
    <div class="ods-header__logo ods-grid ods-grid--gutter">
      <figure class="ods-logo">
        <a :href="logoLink" aria-label="Tilbake til forsiden">
          <ods-logo />
        </a>
      </figure>
    </div>
    <div class="ods-header__content">
      <div class="ods-block-breakpoint-medium ods-height-100">
        <div class="ods-grid ods-grid--gutter ods-height-100">
          <div class="ods-grid__column--start-13 ods-grid__column--end-13-breakpoint-medium">
            <div class="ods-height-100 ods-flex ods-flex-justify-content-flex-end ods-flex-align-items-center">
              <div class="ods-margin-right-8-breakpoint-large">
                <div v-if="!canChangeRepresentation">
                  <span class="ods-text--size-juliett ods-text--weight-light ods-padding-right-1">{{
                    representing
                  }}</span
                  ><span
                    class="ods-icon ods-icon--align-right ods-icon--size-juliett ods-icon--user ods-none ods-inline-block-breakpoint-medium"
                    aria-hidden="true"
                  ></span>
                </div>
                <button
                  v-else
                  class="ods-button ods-button ods-button--outline"
                  type="button"
                  @click="$emit('changeRepresentation')"
                >
                  <span
                    class="ods-text--weight-light ods-text--size-juliett ods-none ods-inline-block-breakpoint-medium"
                    >{{ representing }}</span
                  >
                  <span class="ods-padding-left-5-breakpoint-medium ods-padding-right-1-breakpoint-medium">Endre</span>
                  <span
                    class="ods-button__icon ods-button__icon--right ods-icon--user ods-none ods-inline-block-breakpoint-medium"
                  ></span>
                </button>
              </div>
              <button type="button" class="ods-button ods-button--text" @click="$emit('logout')">
                Logg ut<span
                  class="ods-button__icon ods-button__icon--right ods-icon--exit ods-none ods-inline-block-breakpoint-medium"
                ></span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import OdsLogo from './OdsLogo.vue';

export default {
  name: 'OdsHeader',
  components: { OdsLogo },
  props: {
    canChangeRepresentation: {
      type: Boolean,
      required: true,
    },
    isLoggedIn: {
      type: Boolean,
      required: true,
    },
    logoLink: {
      type: String,
      required: true,
      default: 'https://www.oslo.kommune.no/',
    },
    representing: {
      type: String,
      required: true,
    },
  },

  emits: ['logout', 'changeRepresentation'],
};
</script>
